var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEinzelschliessendV2 = function SvgEinzelschliessendV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8h8V0H0Zm10 10h8v-8h-8ZM0 18h8v-8H0Zm2-6h4v4H2Zm8-12v8h8V0Zm6 6h-4V2h4Z",
    "data-name": "Ebene 2"
  })));
};
export default SvgEinzelschliessendV2;